<div class="rcc-modal">
  <!-- Header -->
  <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200">
    <div class="flex items-center gap-2">
      <mat-icon style="color:#1C593D;">tune</mat-icon>
      <h2 class="text-lg font-bold text-gray-800">Rail Colombia — Precio al cliente</h2>
    </div>
    <button (click)="close()" class="text-gray-400 hover:text-gray-700"><mat-icon>close</mat-icon></button>
  </div>

  <div class="px-5 py-4 overflow-y-auto" style="max-height:75vh;">

    <div *ngIf="error" class="mb-3 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">{{ error }}</div>
    <div *ngIf="okMsg" class="mb-3 px-3 py-2 rounded-lg bg-emerald-50 border border-emerald-200 text-sm text-emerald-700">✓ {{ okMsg }}</div>

    <!-- Divergencia entre rieles (estado inconsistente — incidente 2026-06-06) -->
    <div *ngIf="divergencia" class="mb-3 px-3 py-2 rounded-lg bg-red-50 border border-red-300 text-sm text-red-700">
      🔴 <strong>Los rieles quedaron con estrategias DISTINTAS</strong> (uno iguala a Vita y el otro cobra comisión propia):
      el cliente ve precios inconsistentes entre formas de entrega. Guardá para alinearlos — el Guardar escribe ambos.
    </div>

    <!-- Ofrecer USD→COP (master de COP). Si se apaga, el backend tampoco ofrece CLP→COP. -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 mb-4 p-4 flex items-center justify-between gap-3">
      <div>
        <div class="font-bold text-sm" style="color:#1e5a3f;">Ofrecer USD→COP al cliente</div>
        <div class="text-xs text-gray-500 mt-0.5">
          Maestro del destino Colombia. Si lo apagás, <b>no se ofrece USD→COP ni CLP→COP</b> (CLP usa este mismo puente).
        </div>
      </div>
      <button type="button" (click)="usdCopOfrecido = !usdCopOfrecido" [disabled]="saving"
        [style.background]="usdCopOfrecido ? '#1C593D' : '#cbd5e1'"
        style="position:relative;width:52px;height:30px;border:none;border-radius:999px;cursor:pointer;flex-shrink:0;transition:background .2s;">
        <span [style.left]="usdCopOfrecido ? '25px' : '3px'"
          style="position:absolute;top:3px;width:24px;height:24px;border-radius:50%;background:#fff;transition:left .2s;"></span>
      </button>
    </div>

    <!-- Estrategia (una sola decisión, aplica a AMBOS rieles) -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-4">
      <div style="background:linear-gradient(135deg,#f0fdf4,#ecfdf5);padding:12px 16px;border-bottom:2px solid #bbf7d0;">
        <h3 class="font-bold text-sm" style="color:#1e5a3f;">Estrategia de precio <span class="font-normal text-gray-500">(aplica a ambos rieles)</span></h3>
      </div>
      <div class="p-4 flex flex-col gap-3">

        <label class="flex items-start gap-3 p-3 rounded-xl border cursor-pointer"
          [class.border-emerald-400]="pais.estrategia === 'ESPEJO'" [class.bg-emerald-50]="pais.estrategia === 'ESPEJO'"
          [class.border-gray-200]="pais.estrategia !== 'ESPEJO'">
          <input type="radio" name="estrategia" value="ESPEJO" [(ngModel)]="pais.estrategia" (ngModelChange)="onFormChange()" class="mt-1" />
          <span>
            <span class="font-semibold text-sm text-gray-800">🪞 Igualar a Vita automáticamente (sin perder)</span>
            <span class="block text-xs text-gray-500 mt-0.5">
              El cliente recibe lo MISMO que recibiría en Vita, en vivo, solo. Si igualar dejara menos que el
              margen mínimo, el precio flota apenas arriba de Vita — <strong>nunca a pérdida</strong>.
            </span>
          </span>
        </label>

        <label class="flex items-start gap-3 p-3 rounded-xl border cursor-pointer"
          [class.border-emerald-400]="pais.estrategia === 'A'" [class.bg-emerald-50]="pais.estrategia === 'A'"
          [class.border-gray-200]="pais.estrategia !== 'A'">
          <input type="radio" name="estrategia" value="A" [(ngModel)]="pais.estrategia" (ngModelChange)="onFormChange()" class="mt-1" />
          <span class="flex-1">
            <span class="font-semibold text-sm text-gray-800">💼 Comisión propia (Modelo A)</span>
            <span class="block text-xs text-gray-500 mt-0.5">Tasa de referencia intacta + tu comisión. No sigue a Vita: si Vita mejora su oferta, quedás caro hasta ajustar a mano.</span>
            <span *ngIf="pais.estrategia === 'A'" class="flex gap-3 mt-2">
              <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Comisión %
                <input type="number" step="0.01" min="0" [(ngModel)]="pais.comisionPct" (ngModelChange)="onFormChange()" name="comisionPct"
                  class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm w-28" /></label>
              <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1">Fijo USD
                <input type="number" step="0.01" min="0" [(ngModel)]="pais.fijoUsd" (ngModelChange)="onFormChange()" name="fijoUsd"
                  class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm w-28" /></label>
            </span>
          </span>
        </label>

        <label class="flex items-center gap-3 text-sm font-semibold text-gray-700"
          title="Piso de utilidad por operación, en USD. En 'Igualar a Vita' activa el clamp: si igualar deja menos que esto, el precio flota apenas arriba de Vita. OJO: un piso alto te deja SIEMPRE abajo de Vita — con el squeeze actual, igualar deja ~0.42 USD/op.">
          Nunca ganar menos de
          <input type="number" step="0.01" min="0" [(ngModel)]="pais.margenMinUsd" (ngModelChange)="onFormChange()" name="margenMinUsd"
            class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm w-24" />
          USD por operación ⓘ
        </label>
      </div>
    </div>

    <!-- Tabla comparativa EN VIVO (config del form, sin guardar) -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-4">
      <div style="background:linear-gradient(135deg,#eff6ff,#eef2ff);padding:12px 16px;border-bottom:2px solid #bfdbfe;" class="flex items-center justify-between">
        <h3 class="font-bold text-sm" style="color:#1e40af;">Así queda vs Vita (en vivo, antes de guardar)</h3>
        <span *ngIf="previewLoading" class="text-xs text-gray-400">calculando…</span>
      </div>
      <div class="p-4">
        <div *ngIf="preview?.publicaStale" class="mb-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-700">
          ⚠️ La oferta pública de Vita no está disponible ahora (rate-limit). La comparación no se puede mostrar; en "Igualar a Vita" el sistema degrada solo a comisión propia mientras tanto.
        </div>
        <div *ngIf="espejoDegradado && !preview?.publicaStale" class="mb-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-700">
          ⚠️ Espejo degradado: sin oferta retail viva de Vita, estas cotizaciones salen por comisión propia.
        </div>
        <div *ngIf="hayClamp" class="mb-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-700">
          ⚠️ El margen mínimo impide igualar a Vita en los montos marcados — el cliente recibe MENOS que en Vita (flotamos arriba del piso). Si la meta es igualar, bajá el margen mínimo.
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div *ngFor="let rail of rails">
            <p class="text-xs font-bold mb-1" style="color:#1e5a3f;">
              {{ railLabel[rail] }}
              <span class="font-normal text-gray-400">· tasa Aguacate {{ partnerDe(rail) ? (partnerDe(rail) | number:'1.2-2') : '—' }} · fee {{ feeDe(rail) != null ? (feeDe(rail) | number:'1.0-0') : '—' }} COP · {{ diasDe(rail) != null ? diasDe(rail) + 'd' : '—' }}</span>
            </p>
            <table class="w-full text-sm">
              <thead>
                <tr class="text-[11px] text-gray-400 text-left">
                  <th class="py-1 font-semibold">Envía USD</th>
                  <th class="py-1 font-semibold text-right">Vita da</th>
                  <th class="py-1 font-semibold text-right">Damos</th>
                  <th class="py-1 font-semibold text-right">Ganancia</th>
                  <th class="py-1 font-semibold text-center">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let it of itemsDe(rail)" class="border-t border-gray-100">
                  <td class="py-1.5 font-semibold text-gray-700">{{ it.montoUsd | number:'1.0-0' }}</td>
                  <td class="py-1.5 text-right text-gray-600">{{ it.ofertaVitaCop != null ? (it.ofertaVitaCop | number:'1.0-0') : '—' }}</td>
                  <td class="py-1.5 text-right font-bold" style="color:#1e5a3f;">{{ recibeDe(it) != null ? (recibeDe(it) | number:'1.0-0') : '—' }}</td>
                  <td class="py-1.5 text-right" [style.color]="(gananciaDe(it) || 0) > 0 ? '#1e40af' : '#b91c1c'">
                    {{ gananciaDe(it) != null ? (gananciaDe(it) | number:'1.2-2') : '—' }}
                  </td>
                  <td class="py-1.5 text-center text-xs">
                    <ng-container *ngIf="it.quote.disponible && recibeDe(it) != null; else noDisp">
                      <span *ngIf="!margenOkDe(it)" class="text-red-600" title="Ganancia bajo el piso: el cliente vería 'no disponible'">🔴 no se ofrece</span>
                      <span *ngIf="margenOkDe(it) && clampedDe(it)" class="text-amber-600"
                        title="Piso de margen activo: el cliente recibe MENOS que en Vita">⚠️ bajo Vita ({{ difVsVita(it) | number:'1.0-0' }})</span>
                      <span *ngIf="margenOkDe(it) && !clampedDe(it) && difVsVita(it) != null && difVsVita(it)! >= 0" class="text-emerald-600">✓ igualada</span>
                      <span *ngIf="margenOkDe(it) && !clampedDe(it) && difVsVita(it) != null && difVsVita(it)! < 0" class="text-amber-600">{{ difVsVita(it) | number:'1.0-0' }} vs Vita</span>
                      <span *ngIf="margenOkDe(it) && !clampedDe(it) && difVsVita(it) == null" class="text-gray-400">sin ref. Vita</span>
                    </ng-container>
                    <ng-template #noDisp><span class="text-red-600">🔴 {{ it.quote.motivo || 'no disponible' }}</span></ng-template>
                  </td>
                </tr>
                <tr *ngIf="!itemsDe(rail).length"><td colspan="5" class="py-2 text-xs text-gray-400">{{ previewLoading ? 'calculando…' : 'sin datos' }}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Avanzado (contingencia, por riel) -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-4">
      <button (click)="mostrarAvanzado = !mostrarAvanzado" class="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold text-gray-600">
        <span>⚙️ Avanzado — contingencia por riel (tasa manual, costo fijo)</span>
        <mat-icon class="text-gray-400">{{ mostrarAvanzado ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <div *ngIf="mostrarAvanzado" class="px-4 pb-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div *ngFor="let rail of rails" class="border border-gray-100 rounded-xl p-3">
          <p class="text-xs font-bold mb-2" style="color:#1e5a3f;">{{ railLabel[rail] }} <span class="text-gray-400 font-normal">{{ esVigente(rail) ? '' : '· sin config previa' }}</span></p>
          <div class="grid grid-cols-2 gap-2">
            <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1"
              title="De dónde sale la tasa de COSTO. AUTO: tasa viva del proveedor (lo normal). MANUAL: contingencia si el feed se cae — tasa fija con vencimiento, al vencer vuelve sola a AUTO.">Modo tasa ⓘ
              <select [(ngModel)]="avanzado[rail].modoTasa" name="modoTasa-{{rail}}" class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm">
                <option value="AUTO">AUTO (vivo)</option><option value="MANUAL">MANUAL</option>
              </select></label>
            <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1"
              title="Costo operativo interno EXTRA en COP por operación (reduce la ganancia, no la entrega). NO pongas acá el fee del proveedor: ese ya entra solo, en vivo. Lo esperado es 0.">Costo fijo COP ⓘ
              <input type="number" step="1" [(ngModel)]="avanzado[rail].costoFijoCop" name="costoFijo-{{rail}}"
                class="border rounded-lg px-2 py-1.5 text-sm" [class.border-amber-400]="costoFijoDuplicaFee(rail)" [class.border-gray-300]="!costoFijoDuplicaFee(rail)" /></label>
            <ng-container *ngIf="avanzado[rail].modoTasa === 'MANUAL'">
              <label class="flex flex-col text-xs font-semibold text-amber-700 gap-1"
                title="Override de la tasa de costo (COP por USD) mientras el feed esté caído. Solo contingencia.">Tasa manual ⓘ
                <input type="number" step="0.01" [(ngModel)]="avanzado[rail].tasaCostoManual" name="tasaManual-{{rail}}" class="border border-amber-300 rounded-lg px-2 py-1.5 text-sm" /></label>
              <label class="flex flex-col text-xs font-semibold text-amber-700 gap-1"
                title="Hasta cuándo vale la tasa manual. Al vencer, vuelve solo a AUTO. Obligatorio en MANUAL.">Vence ⓘ
                <input type="datetime-local" [(ngModel)]="avanzado[rail].tasaManualVigenteHasta" name="vence-{{rail}}" class="border border-amber-300 rounded-lg px-2 py-1.5 text-sm" /></label>
            </ng-container>
          </div>
          <div *ngIf="costoFijoDuplicaFee(rail)" class="mt-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-700">
            ⚠️ El fee del proveedor ({{ feeDe(rail) != null ? (feeDe(rail) | number:'1.0-0') + ' COP' : 'en vivo' }}) ya se descuenta solo. Esto es solo costo interno <strong>adicional</strong> — repetirlo lo cuenta doble. Lo esperado es <strong>0</strong>.
          </div>
        </div>
      </div>
    </div>

    <!-- Motivo + Guardar (UN botón = AMBOS rieles) -->
    <div class="flex items-end gap-3">
      <label class="flex flex-col text-xs font-semibold text-gray-600 gap-1 flex-1"
        title="Por qué hacés este cambio. Queda en el historial de versiones con tu usuario y fecha.">Motivo (opcional) ⓘ
        <input type="text" [(ngModel)]="pais.motivo" name="motivo" class="border border-gray-300 rounded-lg px-2 py-1.5 text-sm" /></label>
      <button (click)="saveAll()" [disabled]="saving || loading" class="px-5 py-2 rounded-lg text-white text-sm font-semibold" style="background:#1C593D;">
        {{ saving ? 'Guardando…' : 'Guardar (ambos rieles)' }}
      </button>
    </div>
    <p class="text-[11px] text-gray-400 mt-2">
      La <strong>activación</strong> del servicio es el toggle del país en el catálogo. Cada Guardar crea una versión nueva
      (auditable) en ambos rieles — no pueden quedar con estrategias distintas.
      <span *ngIf="config['COBREB']?.responsible"> Últ. cambio: {{ config['COBREB']?.responsible }}.</span>
    </p>
  </div>
</div>
